import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@/store";

export interface FiltersState {
    selectedFeatures: number[];
    selectedCategories: number[];
    selectedFacilities: number[];
    selectedSort: string;
}

const initialState: FiltersState = {
    selectedFeatures: [],
    selectedCategories: [],
    selectedFacilities: [],
    selectedSort: "",
};

const filtersSlice = createSlice({
    name: "filters",
    initialState,
    reducers: {
        setSelectedFeatures: (state, action: PayloadAction<number[]>) => {
            state.selectedFeatures = action.payload;
        },
        setSelectedCategories: (state, action: PayloadAction<number[]>) => {
            state.selectedCategories = action.payload;
        },
        setSelectedFacilities: (state, action: PayloadAction<number[]>) => {
            state.selectedFacilities = action.payload;
        },
        setSelectedSort: (state, action: PayloadAction<string>) => {
            state.selectedSort = action.payload;
        },
        resetFilters: (state) => {
            state.selectedFeatures = [];
            state.selectedCategories = [];
            state.selectedFacilities = [];
            state.selectedSort = "";
        },
    },
});

export const selectSelectedFeatures = (state: RootState) =>
    state.filters.selectedFeatures;
export const selectSelectedCategories = (state: RootState) =>
    state.filters.selectedCategories;
export const selectSelectedFacilities = (state: RootState) =>
    state.filters.selectedFacilities;
export const selectSelectedSort = (state: RootState) =>
    state.filters.selectedSort;

export const {
    setSelectedFeatures,
    setSelectedCategories,
    setSelectedFacilities,
    setSelectedSort,
    resetFilters,
} = filtersSlice.actions;

export default filtersSlice.reducer;